import {FC} from 'react'
import {IProductModel} from '../../cors/_models'

type IProps = {
  item: IProductModel
  onChange: (productID: number) => void
  selectedProductIDs: number[]
}

const SpecialSelectionTableRow: FC<IProps> = ({item, onChange, selectedProductIDs}) => {
  const isSelected = selectedProductIDs.includes(item.product_id)

  return (
    <tr className={isSelected ? 'is-selected' : ''} onClick={() => onChange(item.product_id)}>
      <td>
        <input
          onChange={() => onChange(item.product_id)}
          onClick={(e) => e.stopPropagation()}
          className='aos-check'
          type='checkbox'
          checked={isSelected}
        />
      </td>
      <td>
        <img src={item.image} className='aos-thumb' alt={item.name} />
      </td>
      <td className='aos-name'>{item.name}</td>
      <td>{item.barcode}</td>
      <td>{item.model}</td>
      <td className='aos-price'>{(+item.price).toFixed(2)}</td>
    </tr>
  )
}

export default SpecialSelectionTableRow
